/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePractitionerRequest
 */
export interface CreatePractitionerRequest {
    /**
     * 
     * @type {string}
     * @memberof CreatePractitionerRequest
     */
    facility_id: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePractitionerRequest
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePractitionerRequest
     */
    last_name: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePractitionerRequest
     */
    npi?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePractitionerRequest
     */
    credential?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePractitionerRequest
     */
    address_line?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePractitionerRequest
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePractitionerRequest
     */
    state?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePractitionerRequest
     */
    zip?: string | null;
}

/**
 * Check if a given object implements the CreatePractitionerRequest interface.
 */
export function instanceOfCreatePractitionerRequest(value: object): value is CreatePractitionerRequest {
    if (!('facility_id' in value) || value['facility_id'] === undefined) return false;
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    return true;
}

export function CreatePractitionerRequestFromJSON(json: any): CreatePractitionerRequest {
    return CreatePractitionerRequestFromJSONTyped(json, false);
}

export function CreatePractitionerRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePractitionerRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'facility_id': json['facility_id'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'npi': json['npi'] == null ? undefined : json['npi'],
        'credential': json['credential'] == null ? undefined : json['credential'],
        'address_line': json['address_line'] == null ? undefined : json['address_line'],
        'city': json['city'] == null ? undefined : json['city'],
        'state': json['state'] == null ? undefined : json['state'],
        'zip': json['zip'] == null ? undefined : json['zip'],
    };
}

export function CreatePractitionerRequestToJSON(json: any): CreatePractitionerRequest {
    return CreatePractitionerRequestToJSONTyped(json, false);
}

export function CreatePractitionerRequestToJSONTyped(value?: CreatePractitionerRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'facility_id': value['facility_id'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'npi': value['npi'],
        'credential': value['credential'],
        'address_line': value['address_line'],
        'city': value['city'],
        'state': value['state'],
        'zip': value['zip'],
    };
}

